import { render, staticRenderFns } from "./UpdateLogo.vue?vue&type=template&id=242d9484&scoped=true"
import script from "./UpdateLogo.vue?vue&type=script&lang=js"
export * from "./UpdateLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242d9484",
  null
  
)

export default component.exports